import { TpDataContext } from '../../../data/interfaces';
import { TpDashboardContext } from '../dashboard/interfaces';
import executeDashboardAction from './executeDashboardAction';

export enum DASHBOARD_ACTION_TRIGGERIDS {
  ENTITY_SELECTION_MODIFIED_BY_USER = 'EntitySelectionModifiedByUser',
}

export const dashboardActionTriggerDefs = [
  {
    type: DASHBOARD_ACTION_TRIGGERIDS.ENTITY_SELECTION_MODIFIED_BY_USER,
    getJsonSchema: () => {
      return {
        type: 'object',
        title: 'Entity Selection Modified By User',
        description:
          'Triggered whenever a user performs an action that modifies the selection of a given entity type in the dashboard.',
        properties: {
          type: { type: 'string', const: 'EntitySelectionModifiedByUser' },
          canonicalTypeId: {
            type: 'string',
            description:
              'Identifier of the entity type for which the selection should be modified to trigger the action.',
          },
        },
        required: ['type', 'canonicalTypeId'],
      };
    },
    execute: (
      dashboardContext: TpDashboardContext,
      dataContext: TpDataContext,
      dispatch: any,
      triggerPayload: any,
      actionDef: any,
      triggerDef: any,
    ) => {
      if (triggerPayload.canonicalTypeId == triggerDef.canonicalTypeId) {
        executeDashboardAction(dataContext, dashboardContext, actionDef, dispatch, {});
      }
    },
  },
];

function findActionTriggerDef(triggerType: string) {
  const def = dashboardActionTriggerDefs.find((def) => def.type == triggerType);
  if (!def) throw `Invalid dashboard action trigger type ${triggerType}`;
  return def;
}

export function executeDashboardTriggers(
  dashboardContext: TpDashboardContext,
  dataContext: TpDataContext,
  dispatch: any,
  triggerType: string,
  payload: any,
) {
  Object.entries(dashboardContext.dashboardActionDefs).forEach(([actionKey, actionDef]) => {
    if ((actionDef as any).triggers) {
      for (const trigger of (actionDef as any).triggers)
        if (trigger.type == triggerType)
          findActionTriggerDef(triggerType).execute(
            dashboardContext,
            dataContext,
            dispatch,
            payload,
            actionDef,
            trigger,
          );
    }
  });
}
